// 22 pSEO area landing pages
export const AREAS = [
  // Batam
  {
    slug: "batu-aji",
    name: "Batu Aji",
    region: "Batam",
    description:
      "Kawasan industri dan perumahan padat di Batam barat dengan kebutuhan instalasi listrik industri, ruko, dan hunian.",
    highlights: ["Kawasan industri", "Perumahan padat", "Ruko & gudang"],
    response: "30 menit",
  },
  {
    slug: "sekupang",
    name: "Sekupang",
    region: "Batam",
    description:
      "Sekupang merupakan pintu gerbang pelabuhan dengan banyak perkantoran, gudang, dan perumahan yang memerlukan layanan listrik profesional.",
    highlights: ["Pelabuhan & logistik", "Perkantoran", "Perumahan"],
    response: "30 menit",
  },
  {
    slug: "baloi",
    name: "Baloi",
    region: "Batam",
    description:
      "Baloi adalah kawasan campuran komersial dan hunian di jantung Batam yang membutuhkan instalasi panel dan maintenance rutin.",
    highlights: ["Komersial", "Hunian", "Kafe & F&B"],
    response: "25 menit",
  },
  {
    slug: "nagoya",
    name: "Nagoya",
    region: "Batam",
    description:
      "Nagoya sebagai pusat bisnis Batam punya banyak hotel, mal, dan ruko yang membutuhkan service listrik 24 jam.",
    highlights: ["Pusat bisnis", "Hotel & mal", "Ruko"],
    response: "20 menit",
  },
  {
    slug: "nongsa",
    name: "Nongsa",
    region: "Batam",
    description:
      "Nongsa dikenal dengan resort, villa, dan kawasan digital park yang memerlukan sistem kelistrikan premium dan stabil.",
    highlights: ["Resort & villa", "Digital park", "Wisata"],
    response: "40 menit",
  },
  {
    slug: "tiban",
    name: "Tiban",
    region: "Batam",
    description:
      "Tiban adalah kawasan hunian padat dengan banyak perumahan koperasi dan ruko—lokasi kantor utama ListrikBatam.com.",
    highlights: ["Hunian padat", "Ruko", "Perumahan koperasi"],
    response: "15 menit",
  },
  {
    slug: "batam-center",
    name: "Batam Center",
    region: "Batam",
    description:
      "Batam Center adalah pusat pemerintahan dan bisnis modern yang memerlukan instalasi panel industri dan smart home.",
    highlights: ["Pusat pemerintahan", "Bisnis modern", "Smart home"],
    response: "25 menit",
  },
  {
    slug: "bengkong",
    name: "Bengkong",
    region: "Batam",
    description:
      "Bengkong dikenal dengan kawasan komersial dan hunian yang padat—kebutuhan perbaikan listrik cepat sangat tinggi.",
    highlights: ["Komersial", "Hunian padat", "UMKM"],
    response: "25 menit",
  },
  {
    slug: "lubuk-baja",
    name: "Lubuk Baja",
    region: "Batam",
    description:
      "Lubuk Baja adalah salah satu kecamatan paling ramai di Batam dengan banyak usaha kuliner dan ritel yang butuh listrik stabil.",
    highlights: ["Ritel & kuliner", "Usaha kecil", "Hunian"],
    response: "20 menit",
  },
  {
    slug: "sagulung",
    name: "Sagulung",
    region: "Batam",
    description:
      "Sagulung meliputi banyak perumahan pekerja pabrik dan kawasan industri—kebutuhan maintenance listrik preventif sangat vital.",
    highlights: ["Perumahan pekerja", "Kawasan industri", "Workshop"],
    response: "35 menit",
  },
  {
    slug: "sei-panas",
    name: "Sei Panas",
    region: "Batam",
    description:
      "Sei Panas adalah kawasan bisnis dan kuliner yang membutuhkan instalasi panel dan grounding yang aman.",
    highlights: ["Bisnis & kuliner", "Perkantoran", "Hunian"],
    response: "25 menit",
  },
  {
    slug: "batu-ampar",
    name: "Batu Ampar",
    region: "Batam",
    description:
      "Batu Ampar sebagai pelabuhan utama butuh instalasi panel industri, lighting gudang, dan backup genset.",
    highlights: ["Pelabuhan", "Gudang & logistik", "Industri"],
    response: "30 menit",
  },
  {
    slug: "marina",
    name: "Marina",
    region: "Batam",
    description:
      "Marina Waterfront City memerlukan layanan listrik premium untuk kondominium, hotel, dan kawasan wisata.",
    highlights: ["Waterfront city", "Kondominium", "Hotel"],
    response: "35 menit",
  },
  {
    slug: "barelang",
    name: "Barelang",
    region: "Batam",
    description:
      "Barelang menghubungkan Batam – Rempang – Galang dengan banyak resort, workshop perahu, dan hunian pesisir.",
    highlights: ["Jembatan ikonik", "Resort pesisir", "Workshop"],
    response: "50 menit",
  },
  // Kepulauan Riau
  {
    slug: "tanjung-pinang",
    name: "Tanjung Pinang",
    region: "Kepulauan Riau",
    description:
      "Ibu kota Kepri yang butuh jasa listrik untuk perkantoran, perhotelan, dan hunian modern.",
    highlights: ["Ibu kota Kepri", "Perkantoran", "Hotel"],
    response: "Proyek terjadwal",
  },
  {
    slug: "karimun",
    name: "Karimun",
    region: "Kepulauan Riau",
    description:
      "Karimun memiliki kawasan industri galangan kapal dan hunian yang memerlukan instalasi listrik industri tahan beban.",
    highlights: ["Galangan kapal", "Industri", "Hunian"],
    response: "Proyek terjadwal",
  },
  {
    slug: "natuna",
    name: "Natuna",
    region: "Kepulauan Riau",
    description:
      "Kepulauan terluar Indonesia dengan kebutuhan instalasi solar panel, genset, dan sistem kelistrikan remote area.",
    highlights: ["Solar panel", "Remote area", "Genset"],
    response: "Proyek terjadwal",
  },
  {
    slug: "anambas",
    name: "Anambas",
    region: "Kepulauan Riau",
    description:
      "Gugusan pulau dengan resort dan pemukiman pesisir yang memerlukan sistem kelistrikan hemat energi dan tahan korosi.",
    highlights: ["Resort", "Pesisir", "Hemat energi"],
    response: "Proyek terjadwal",
  },
  {
    slug: "bintan",
    name: "Bintan",
    region: "Kepulauan Riau",
    description:
      "Bintan adalah destinasi wisata premium dengan banyak resort dan villa mewah yang butuh maintenance listrik terjadwal.",
    highlights: ["Resort mewah", "Villa", "Wisata"],
    response: "Proyek terjadwal",
  },
  {
    slug: "tarempa",
    name: "Tarempa",
    region: "Kepulauan Riau",
    description:
      "Ibu kota Anambas yang sedang berkembang pesat dengan kebutuhan instalasi listrik ruko, hotel kecil, dan rumah tinggal.",
    highlights: ["Kota kecamatan", "Ruko", "Hotel kecil"],
    response: "Proyek terjadwal",
  },
  {
    slug: "moro",
    name: "Moro",
    region: "Kepulauan Riau",
    description:
      "Moro adalah kawasan pesisir Karimun dengan banyak dermaga dan workshop yang membutuhkan sistem kelistrikan tahan kondisi ekstrem.",
    highlights: ["Pesisir", "Dermaga", "Workshop"],
    response: "Proyek terjadwal",
  },
  {
    slug: "kundur",
    name: "Kundur",
    region: "Kepulauan Riau",
    description:
      "Pulau Kundur memiliki perkebunan, industri kecil, dan hunian—solusi listrik stabil jadi kebutuhan utama.",
    highlights: ["Perkebunan", "Industri kecil", "Hunian"],
    response: "Proyek terjadwal",
  },
];

export const AREAS_BATAM = AREAS.filter((a) => a.region === "Batam");
export const AREAS_KEPRI = AREAS.filter((a) => a.region === "Kepulauan Riau");
